import { PICO_API_URL } from '@piconetworks/pkg-endpoints'
import qs from 'qs'
import AppModule from 'modules/app'
import IntegrationsModule from 'modules/integrations'

export const getPopupUrl = (type, publisherId, redirect) => {
    const query = {
        publisher_id: publisherId,
        redirect,
        origin: process.env.HOSTNAME,
    }
    return `${PICO_API_URL()}/connect/${type}?${qs.stringify(query)}`
}

export const loginResponse =
    ({ type, dispatch }) =>
        (authWindow) =>
            ({ origin, data } = {}) => {
                if (origin === PICO_API_URL()) {
                    let response
                    try {
                        response = JSON.parse(data)
                    } catch (error) {
                        response = JSON.parse(JSON.stringify(data))
                    }

                    if (response.error) {
                        dispatch(
                            AppModule.creators.addNotification({
                                message: response.error,
                                type: 'danger',
                            })
                        )
                    } else {
                        dispatch(IntegrationsModule.creators.getIntegrations())
                        dispatch(IntegrationsModule.creators.addIntegration({ type }))
                    }

                    authWindow.close()
                }
            }

export const getSocialPopupUrl = (type, publisherId, redirect) => {
    const query = {
        publisher_id: publisherId,
        redirect,
        origin: process.env.HOSTNAME,
    }
    return `${PICO_API_URL()}/connect/${type}/integration?${qs.stringify(
        query
    )}`
}
